(() => {
  'use strict';
  if (customElements.get('am-mobile-product-heading')) return;

  class MobileProductHeading extends HTMLElement {
    connectedCallback() {
      if (document.readyState === 'loading') {
        this._onReady = () => this.initialize();
        document.addEventListener('DOMContentLoaded', this._onReady, {once: true});
      } else {
        this.initialize();
      }
    }

    initialize() {
      if (this._observer || !this.isConnected) return;
      const section = document.getElementById(`MainProduct-${this.dataset.section}`);
      const options = section?.querySelector('#pack-options');
      const amount = this.querySelector('[data-am-mobile-amount]');
      const label = this.querySelector('[data-am-mobile-pack]');
      const price = this.querySelector('.am-mobile-product-price');
      if (!options || !amount || !label || !price) return;

      // Liquid already supplies the first price. JS only follows later changes
      // to the existing pack selector, using its total and discount calculations.
      const syncPrice = () => {
        const selected = options.querySelector('.pack-option[aria-checked="true"]');
        const value = selected?.querySelector('.tier-price')?.textContent.trim();
        if (!value) return;
        const count = Number(selected.dataset.count || 1);
        const pack = count > 1 ? `Pack de ${count}` : '';
        if (amount.textContent !== value) amount.textContent = value;
        if (label.textContent !== pack) label.textContent = pack;
        price.setAttribute('aria-label', `${pack || 'Precio unitario'}: ${value}`);
      };
      this._observer = new MutationObserver(syncPrice);
      this._observer.observe(options, {
        childList: true,
        subtree: true,
        characterData: true,
        attributes: true,
        attributeFilter: ['aria-checked']
      });
      syncPrice();
    }

    disconnectedCallback() {
      document.removeEventListener('DOMContentLoaded', this._onReady);
      this._observer?.disconnect();
      this._observer = null;
    }
  }

  customElements.define('am-mobile-product-heading', MobileProductHeading);
})();
